module.exports = __webpack_public_path__ + "static/duration_icon-92999a048742cd24d0b63efe7acafb44.svg";